export default (theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
  text: {
    paddingBottom: theme.spacing(2),
    fontSize: 22,
  },
});
